import React from 'react'
// import { Link } from 'react-router-dom';


const Blog4 = () => {

    return (
        <>
        <section className="main-wrapper bg-grey">
          <div className="container">
            <div className="main-content mt-20 ov-hidden">
              <div className="col-md-8 sm-padding">
                <div className="blog-details padding-25 bg-white bd-grey mb-30">
                  <h2 className="mb-5 fw-6">
                    सत्ता में रहते हुए ट्रांसफर-पोस्टिंग और सरकारी नौकरी के नाम पर
                    लालू परिवार ने अकूत संपत्ति बनाई: उमेश सिंह कुशवाहा
                  </h2>
                  <img
                    src="img/श्री-उमेश-सिंह-कुशवाहा.jpeg"
                    alt="श्री-उमेश-सिंह-कुशवाहा"
                    className="img-w1"
                  />
                  <div className="meta-info mb-25 mt-5">
                    <span className="mt-5">
                      <i className="ti-calendar fz-18" />{" "}
                      <a >29 Augest, 2024</a>
                    </span>
                    {/* <span>
                                <i class="ti-user fz-18"></i> Written by <a >David Cameroon</a>
                            </span>
                            <span>
                                <i class="ti-bookmark fz-18"></i> Tagged as <a >Wordpress Development</a>
                            </span> */}
                  </div>
                  {/* blog-details */}
                  <p>
                    बिहार जद(यू0) के माननीय प्रदेश अध्यक्ष श्री उमेश सिंह कुशवाहा ने
                    बुधवार को बयान जारी कर कहा कि नेता प्रतिपक्ष श्री तेजस्वी यादव की
                    राजनीति भ्रष्टाचार की नींव पर खड़ी है। यह बात किसी से छिपी हुई नहीं
                    है कि सत्ता में रहते हुए ट्रांसफर-पोस्टिंग और सरकारी नौकरी के नाम
                    पर उनके माता-पिता ने अवैध अकूत संपत्ति बनाई थी इसलिए आज पूरा
                    परिवार जांच एजेंसियों के रडार पर है और कोर्ट-कचहरी का चक्कर लगा
                    रहा है। उन्होंने कहा कि भ्रष्टाचार जैसे गंभीर विषयों पर बयानबाजी
                    करने से पहले श्री तेजस्वी यादव को अपने परिवार का काला चिट्ठा पलटकर
                    देखना चाहिए, इससे उन्हें भ्रष्टाचार के काले कारनामों की जानकारी
                    मिलेगी।
                  </p>
                  <p>
                    श्री उमेश सिंह कुशवाहा ने कहा कि हमारे नेता माननीय मुख्यमंत्री
                    श्री नीतीश कुमार ने हिंदुस्तान की राजनीति में सादगी और ईमानदारी का
                    मिसाल कायम किया है, लंबे अरसे तक सत्ता में रहने के बावजूद भी हमारे
                    नेता के दामन तक कभी भ्रष्टाचार का एक छींटा नहीं आया। वहीं दूसरी ओर
                    लालू परिवार पूरे देश में भ्रष्टाचार का सबसे बड़ा प्रतीक है। साथ ही
                    उन्होंने कहा कि हमारी सरकार विगत 19 वर्षों से लोक कल्याण के लिए
                    काम कर रही है, प्रदेश को विकसित बनाना और गरीबों के जीवन स्तर में
                    सुधार नीतीश सरकार की प्राथमिकता है।
                  </p>
                  <p>
                    श्री उमेश सिंह कुशवाहा ने तंज कसते हुए कहा कि नेता प्रतिपक्ष श्री
                    तेजस्वी यादव बड़बोलेपन के शिकार हो गए हैं, प्रदेश की जनता भी उनकी
                    बातों को गंभीरता से नहीं लेती है। खोखले और आधारहीन बयानों से नेता
                    प्रतिपक्ष को कोई लाभ नहीं होने वाला है। साथ ही प्रदेश अध्यक्ष ने
                    कहा कि बेलगाम अपराध और बेहिसाब भ्रष्टाचार लालू-राबड़ी के शासनकाल की
                    पहचान रही है, बिहार की जनता पुनः जंगलराज के उस काले दौर में वापस
                    नहीं जाना चाहती है। भ्रष्टाचार में आँकठ डूबे विकास विरोधी ताकतों
                    का मंसूबा कभी कामयाब नहीं होने वाला है।
                  </p>
                  <ul className="single-tags">
                    <li>Tags</li>
                    <li>
                      <a >Sports</a>
                    </li>
                    <li>
                      <a >Travel</a>
                    </li>
                  </ul>
                  <div className="social-share-wrap">
                    <span className="fz-16 text-black fw-6">Share This Article</span>
                    <ul className="share-icon">
                      <li>
                        <a >
                          <i className="ti-facebook" /> Facebook
                        </a>
                      </li>
                      <li>
                        <a >
                          <i className="ti-twitter" /> Twitter
                        </a>
                      </li>
                      <li>
                        <a >
                          <i className="ti-google" /> Google+
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* social-share-wrap */}
                </div>
                {/* /.blog-details */}
                {/* <div class="about-author padding-25 bg-white bd-grey mb-30">
                        <img src="img/author-thumb.jpg" alt="Author Thumb">
                        <div class="author-info">
                            <h3><a >John Doe</a></h3>
                            <p class="fz-13">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Earum sunt voluptatem soluta obcaecati ex hic maxime quod voluptates similique iusto. Earum sunt voluptatem soluta ex hic similique iusto.</p>
                            <ul class="social-icon-black social-left">
                                <li><a ><i class="ti-facebook"></i></a></li>
                                <li><a ><i class="ti-twitter"></i></a></li>
                                <li><a ><i class="ti-google"></i></a></li>
                            </ul>
                        </div>
                    </div>/.about-author */}
              </div>
              {/* content block */}
              <aside className="col-md-4 sm-padding">
                <div className="sidebar-wrap">
                  {/* <div class="single-sidebar bd-grey bg-white">
                            <a ><img src="img/banner-2.jpg" alt="Sidebar Ad" class="img-w1"></a>
                        </div>/.single-sidebar */}
                  <div className="single-sidebar no-padding">
                    <a
                      href="https://www.accuweather.com/en/us/new-york-ny/10007/weather-forecast/349727"
                      className="aw-widget-legal"
                    >
                      {/*
                                By accessing and/or using this code snippet, you agree to AccuWeather’s terms and conditions (in English) which can be found at https://www.accuweather.com/en/free-weather-widgets/terms and AccuWeather’s Privacy Statement (in English) which can be found at https://www.accuweather.com/en/privacy.
                                */}
                    </a>
                    <div
                      id="awcc1499974479079"
                      className="aw-widget-current"
                      data-locationkey=""
                      data-unit="c"
                      data-language="en-us"
                      data-useip="true"
                      data-uid="awcc1499974479079"
                    />
                  </div>
                  {/* /.single-sidebar */}
                  <div className="single-sidebar no-padding">
                    <div className="side-tab">
                      <ul className="tab-menu mb-15">
                        <li className="active">
                          <a href="#recent" data-toggle="tab">
                            Recent
                          </a>
                        </li>
                        <li>
                          <a href="#popular" data-toggle="tab">
                            Popular
                          </a>
                        </li>
                        <li>
                          <a href="#comments" data-toggle="tab">
                            Comments
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content bd-grey padding-15">
                        <div className="tab-pane fade in active" id="recent">
                          <ul className="list-post-items">
                            <li>
                              <img src="img/tab-1.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >William Braynt went to visit the US.</a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-2.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    Style icon angelina goes to take oscar.
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-3.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    How to become a wildlife photographer?
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-4.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    linin park singer is no more. he is top in the
                                    world.
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>{" "}
                        {/* /#recent */}
                        <div className="tab-pane fade in" id="popular">
                          <ul className="list-post-items">
                            <li>
                              <img src="img/tab-1.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-2.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-3.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-4.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>{" "}
                        {/* /#popular */}
                        <div className="tab-pane fade in" id="comments">
                          <ul className="list-post-items">
                            <li>
                              <img src="img/tab-1.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-2.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-3.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                            <li>
                              <img src="img/tab-4.jpg" alt="Image" />
                              <div className="list-post-content bd-grey">
                                <h4 className="fz-14">
                                  <a >
                                    William Braynt went to visit the grabl
                                  </a>
                                </h4>
                                <p className="fz-12 fw-6 tt-u no-margin">
                                  national Octobar 2023
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>{" "}
                        {/* /#comments */}
                      </div>
                    </div>
                  </div>
                  {/* /.single-sidebar */}
                  <div className="single-sidebar">
                    <h3 className="fw-8 fz-18 tt-u mb-30">Subscribe News24</h3>
                    <form action="#" className="subscribe-form">
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter Your Email"
                      />
                      <input type="submit" defaultValue="Subscribe" />
                    </form>
                  </div>
                  {/* /.single-sidebar */}
                  <div className="single-sidebar">
                    <div id="calendar_wrap" className="calendar_wrap">
                      <table id="wp-calendar">
                        <caption>Agust 2024</caption>
                        <thead>
                          <tr>
                            <th scope="col" title="Monday">
                              M
                            </th>
                            <th scope="col" title="Tuesday">
                              T
                            </th>
                            <th scope="col" title="Wednesday">
                              W
                            </th>
                            <th scope="col" title="Thursday">
                              T
                            </th>
                            <th scope="col" title="Friday">
                              F
                            </th>
                            <th scope="col" title="Saturday">
                              S
                            </th>
                            <th scope="col" title="Sunday">
                              S
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={3} id="prev" className="pad">
                              &nbsp;
                            </td>
                            <td className="pad">&nbsp;</td>
                            <td colSpan={3} id="next" className="pad">
                              &nbsp;
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr>
                            <td colSpan={5} className="pad">
                              &nbsp;
                            </td>
                            <td>1</td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>4</td>
                            <td>5</td>
                            <td>6</td>
                            <td>7</td>
                            <td>
                              <a
                                href="http://cracktheme.com/codehube/2024/07/08/"
                                aria-label="Posts published on July 8, 2023"
                              >
                                8
                              </a>
                            </td>
                            <td>9</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>11</td>
                            <td>
                              <a
                                href="http://cracktheme.com/codehube/2024/07/12/"
                                aria-label="Posts published on July 12, 2023"
                              >
                                12
                              </a>
                            </td>
                            <td>
                              <a
                                href="http://cracktheme.com/codehube/2024/07/13/"
                                aria-label="Posts published on July 13, 2023"
                              >
                                13
                              </a>
                            </td>
                            <td>14</td>
                            <td>15</td>
                            <td>16</td>
                          </tr>
                          <tr>
                            <td>17</td>
                            <td>18</td>
                            <td>19</td>
                            <td id="today">20</td>
                            <td>21</td>
                            <td>22</td>
                            <td>23</td>
                          </tr>
                          <tr>
                            <td>24</td>
                            <td>25</td>
                            <td>26</td>
                            <td>27</td>
                            <td>28</td>
                            <td>29</td>
                            <td>30</td>
                          </tr>
                          <tr>
                            <td>31</td>
                            <td className="pad" colSpan={6}>
                              &nbsp;
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.single-sidebar */}
                </div>
                {/* /.sidebar-wrap */}
              </aside>
              {/* sidebar block */}
            </div>
            {/* /.main-content */}
          </div>
          {/* /.container */}
        </section>
        {/* /.main-wrapper */}
      </>
      
      
    )
}

export default Blog4;